import SectionTitle from "./common/SectionTitle";
import { SERVICES } from "../constants/data";
import { useInView } from "../hooks/useInView";

export default function Services() {
  const [servRef, servVis] = useInView();

  return (
    <div
      id="services"
      style={{
        padding: "80px 20px",
        background: "linear-gradient(135deg,#f8faff 0%,#eff6ff 100%)",
      }}
    >
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <SectionTitle
          tag="Expertise"
          title="Conditions & Treatments"
          sub="Comprehensive kidney care covering the full spectrum of nephrology and transplant medicine"
        />

        <div
          ref={servRef}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4,1fr)",
            gap: 18,
            opacity: servVis ? 1 : 0,
            transform: servVis ? "translateY(0)" : "translateY(30px)",
            transition: "all 0.7s ease",
          }}
        >
          {SERVICES.map((service, i) => (
            <div
              key={i}
              style={{
                background: "white",
                borderRadius: 20,
                padding: "24px 20px",
                border: "1px solid #e2e8f0",
                boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                cursor: "default",
                transition: "all 0.3s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow =
                  "0 12px 32px rgba(29,78,216,0.12)";
                e.currentTarget.style.transform = "translateY(-4px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.04)";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <div style={{ fontSize: 38, marginBottom: 14 }}>
                {service.icon}
              </div>
              <h3
                style={{
                  fontWeight: 700,
                  color: "#1e293b",
                  marginBottom: 8,
                  fontSize: 14,
                }}
              >
                {service.title}
              </h3>
              <p style={{ color: "#64748b", fontSize: 12, lineHeight: 1.7 }}>
                {service.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
